import React from "react";
import { Btn, Type } from '@saladbob/sassafras'

import formatDollars from "../../utils/formatDollars";

type Props = {
    children?: React.ReactNode;
    price,
    [key: string]: any;
};

const CheckoutBtn: React.FC<Props> = ({ children, price, ...props }) => {
    return (
        <Btn
            size="xl"
            font="h3"
            color="black"
            weight="bold"
            padding={[0, 'lg', 0, 0]}
            iconLeft={
                <Type
                    bgColor="white"
                    color="black"
                    font="control"
                    padding={['xs', 'sm']}
                    rounded="md"
                    me="sm"
                    display="inline-block"
                >
                    {formatDollars(price)}
                </Type>
            }
            {...props}
        >
            {children || 'CHECKOUT'}
        </Btn>
    );
}

export default CheckoutBtn;